import { faSignOutAlt, faInfoCircle, faCoins, faUser } from '@fortawesome/free-solid-svg-icons';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { domainEnvironment } from '@awread/global/environments';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CloseOnOutsideDirective } from '@awread/global/packages';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AvatarSizePipe } from '@awread/core/users';

@Component({
  standalone: true,
  selector: 'menu-navtop',
  imports: [CommonModule, FontAwesomeModule, RouterModule, CloseOnOutsideDirective, AvatarSizePipe],
  templateUrl: './menu-navtop.atom.html',
  styleUrls: ['./menu-navtop.atom.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuNavtopAtom implements OnInit {
  @Input() faIcon = { faSignOutAlt, faInfoCircle, faCoins, faUser };
  @Input() isMenuOpen = false;
  version = domainEnvironment.appVersion;
  timestamp = domainEnvironment.timestamp;
  @Input() user: any;
  @Output() signoutEvent = new EventEmitter();
  constructor() { }

  ngOnInit(): void { }

  toggleMenu(event: any) {
    if (event) event.stopPropagation();
    this.isMenuOpen = !this.isMenuOpen;
  }
}
